var PsrCityAutocomplete = (function() {
    var cachedDOM = {};

    return {
        setInputTarget: function(options) {
            cachedDOM.$autocompleteInput = $("#" + options.elementId);
            cachedDOM.$autocompleteWrap = cachedDOM.$autocompleteInput.parent(
                ".form-profile__input-wrapper"
            );
            cachedDOM.$cityInput = $("[name='city']");
            cachedDOM.$stateInput = $("[name='state']");
            cachedDOM.$countryInput = $("[name='country']");
            cachedDOM.$autocompleteList = cachedDOM.$autocompleteWrap.find(
                ".psr-autocomplete__list"
            );
            cachedDOM.$inputLoader = cachedDOM.$autocompleteWrap.find(
                ".psr-autocomplete__loader"
            );
            cachedDOM.autocompleteItemTemplate =
                "<span data-cityid='{CityID}' data-countryid='{CountryID}' data-estateid='{EstateID}' data-value='{value}' data-label='{label}' class='psr-autocomplete__item psr-text is-small'>{label}</span>";
            cachedDOM.timer = null;
            cachedDOM.cityList = [];
            cachedDOM.selectedCity = null;

            PsrCityAutocomplete.removeReadonly();
            PsrCityAutocomplete.closeAutocompleteList();

            this.events();
        },

        events: function() {
            cachedDOM.$autocompleteInput.keyup(function(event) {
                if (cachedDOM.timer) {
                    clearTimeout(cachedDOM.timer);
                }

                cachedDOM.timer = setTimeout(
                    PsrCityAutocomplete.checkQuery,
                    300
                );
            });

            cachedDOM.$autocompleteInput.on("change", function(event) {
                if (!event.target.value) {
                    cachedDOM.selectedCity = null;
                    PsrCityAutocomplete.render();
                }
            });

            cachedDOM.$autocompleteList.on(
                "click",
                ".psr-autocomplete__item",
                PsrCityAutocomplete.handleSelectCity
            );
        },

        emptyFields: function() {
            cachedDOM.$autocompleteInput.val("");
            PsrCityAutocomplete.removeSelectedCity();
        },

        handleSelectCity: function(event) {
            var clickedElement = event.target;

            cachedDOM.selectedCity = {
                cityId: clickedElement.dataset.cityid,
                stateId: clickedElement.dataset.estateid,
                countryId: clickedElement.dataset.countryid,
                label: clickedElement.dataset.label,
                value: clickedElement.dataset.value
            };

            PsrCityAutocomplete.closeAutocompleteList();
            PsrCityAutocomplete.render();
            PsrCityAutocomplete.openEditField();
        },

        openEditField: function() {
            cachedDOM.$autocompleteInput.prop("readonly", true);
            cachedDOM.$autocompleteWrap.addClass("is-readonly");
            cachedDOM.$autocompleteWrap.append(
                '<button class="psr-autocomplete__button c-btn-tertiary">Editar</button>'
            );

            $(".psr-autocomplete__button").on("click", function() {
                PsrCityAutocomplete.removeReadonly(true);
                cachedDOM.selectedCity = null;

                PsrCityAutocomplete.render();
            });
        },

        removeReadonly: function(focus) {
            cachedDOM.$autocompleteInput.prop("readonly", false);
            cachedDOM.$autocompleteWrap.removeClass("is-readonly");
            $(".psr-autocomplete__button").remove();

            if (focus) {
                PsrCityAutocomplete.focusField();
            }
        },

        focusField: function() {
            cachedDOM.$autocompleteInput.val("").focus();
        },

        showLoader: function() {
            cachedDOM.$inputLoader.each(function() {
                $(this)
                    .parent()
                    .addClass("is-active");
            });
        },

        hideLoader: function() {
            cachedDOM.$inputLoader.each(function() {
                $(this)
                    .parent()
                    .removeClass("is-active");
            });
        },

        checkQuery: function() {
            var inputSearch = cachedDOM.$autocompleteInput.val();
            var queryUrl = "/apiV1/cities/list?search=" + inputSearch;

            if (inputSearch.length <= 0) {
                return false;
            }

            PsrCityAutocomplete.showLoader();

            $.ajax({
                type: "GET",
                url: queryUrl,
                dataType: "json"
            }).done(function(data) {
                cachedDOM.cityList = data;

                PsrCityAutocomplete.populateCityList();
                PsrCityAutocomplete.render();
            });
        },

        populateCityList: function() {
            var listHtml = "";

            if (cachedDOM.cityList.length <= 0) {
                return PsrCityAutocomplete.closeAutocompleteList();
            }

            cachedDOM.cityList.forEach(function(city) {
                var listItem = cachedDOM.autocompleteItemTemplate;

                listItem = listItem.replace("{CityID}", city.CityID);
                listItem = listItem.replace("{EstateID}", city.EstateID);
                listItem = listItem.replace("{CountryID}", city.CountryID);
                listItem = listItem.replace(/{label}/g, city.label);
                listItem = listItem.replace("{value}", city.value);

                listHtml += listItem;
            });

            cachedDOM.$autocompleteList.empty().append(listHtml);
            PsrCityAutocomplete.openAutocompleteList();
        },

        openAutocompleteList: function() {
            cachedDOM.$autocompleteList.addClass("is-active");
        },

        closeAutocompleteList: function() {
            cachedDOM.$autocompleteList.removeClass("is-active");
        },

        removeSelectedCity: function() {
            cachedDOM.$cityInput.val("");
            cachedDOM.$stateInput.val("");
            cachedDOM.$countryInput.val("");
        },

        render: function() {
            PsrCityAutocomplete.removeSelectedCity();

            if (cachedDOM.selectedCity) {
                cachedDOM.$autocompleteInput.val(cachedDOM.selectedCity.label);
                cachedDOM.$cityInput.val(cachedDOM.selectedCity.cityId);
                cachedDOM.$stateInput.val(cachedDOM.selectedCity.stateId);
                cachedDOM.$countryInput.val(cachedDOM.selectedCity.countryId);

                cachedDOM.selectedCity = null;
            }

            PsrCityAutocomplete.hideLoader();
        }
    };
})();
